// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const GlassBreak = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M19.4050907,17.2189411 L26.0170196,7.29998779 L16.0991263,7.29998779 L12.449912,18.2488007 C12.2731622,18.7791068 12.5839202,19.2027318 13.1414302,19.2027318 L17.5868103,19.2027318 L14.3577392,32.1203966 C14.2257927,32.6482392 14.4112026,32.751339 14.7759115,32.3344843 L27.3402344,17.9737233 C27.7105892,17.5504154 27.5503936,17.2189411 26.9950379,17.2189411 L19.4050907,17.2189411 Z M21.2734971,16.2189411 L26.9950379,16.2189411 C28.4067819,16.2189411 29.0307884,17.5601393 28.092846,18.632188 L15.528523,32.992949 C14.4733343,34.199008 13.0008076,33.4251829 13.3875906,31.8778854 L16.3060671,20.2027318 L13.1414302,20.2027318 C11.902361,20.2027318 11.1083304,19.1113941 11.5012186,17.9326034 L15.3783427,6.29998779 L27.8854259,6.29998779 L21.2734971,16.2189411 Z" />
        </G>
    );
};

export default GlassBreak;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/glass-break/index.js